import { Sheet, SheetContent } from '@e2n/ui';
import { UpdateTerminKalenderSheetForm } from '@/domain/termine/features/UpdateTerminkalender/Desktop/UpdateTerminKalenderSheetForm';
import { UpdateTerminKalenderSheetHeader } from '@/domain/termine/features/UpdateTerminkalender/Desktop/UpdateTerminKalenderSheetHeader';
import { useUpdateTerminKalenderForm } from '@/domain/termine/features/UpdateTerminkalender/shared';
import { useTerminKalenderList } from '@/domain/termine/hooks/useTerminKalenderList';

type UpdateTerminKalenderSheetProps = {
  onOpenChange: (open: boolean) => void;
  selectedId: string;
  open: boolean;
};

export function UpdateTerminKalenderSheet({
  onOpenChange,
  selectedId,
  open,
}: UpdateTerminKalenderSheetProps) {
  const { kalender } = useTerminKalenderList();
  const selectedKalender = kalender.find((k) => k.id === selectedId);

  const form = useUpdateTerminKalenderForm(selectedKalender);

  const handleSubmitSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        className="flex flex-col h-full p-0 w-full sm:max-w-md"
        removeCloseIcon>
        <UpdateTerminKalenderSheetHeader />
        <UpdateTerminKalenderSheetForm
          form={form}
          onSubmitSuccess={handleSubmitSuccess}
        />
      </SheetContent>
    </Sheet>
  );
}
